###
 (c) 2013, Vladimir Agafonkin
 Simplify.js, a high-performance JS polyline simplification library
 mourner.github.io/simplify-js/
###

getSqDist = (p1, p2) ->
  dx = p1.x - (p2.x)
  dy = p1.y - (p2.y)
  dx * dx + dy * dy

getSqSegDist = (p, p1, p2) ->
  x = p1.x
  y = p1.y
  dx = p2.x - x
  dy = p2.y - y

  if dx isnt 0 or dy isnt 0
    t = ((p.x - x) * dx + (p.y - y) * dy) / (dx * dx + dy * dy)
    if t > 1
      x = p2.x
      y = p2.y
    else if t > 0
      x += dx * t
      y += dy * t

  dx = p.x - x
  dy = p.y - y
  dx * dx + dy * dy

simplifyRadialDist = (points, sqTolerance) ->
  prevPoint = points[0]
  newPoints = [prevPoint]

  for point in points.slice(1)
    if getSqDist(point, prevPoint) > sqTolerance
      newPoints.push point
      prevPoint = point

  newPoints.push point if prevPoint isnt point

  newPoints

simplifyDPStep = (points, first, last, sqTolerance, simplified) ->
  maxSqDist = sqTolerance

  for i in [first + 1...last]
    sqDist = getSqSegDist(points[i], points[first], points[last])
    if sqDist > maxSqDist
      index = i
      maxSqDist = sqDist

  if maxSqDist > sqTolerance
    if index - first > 1
      simplifyDPStep points, first, index, sqTolerance, simplified

    simplified.push points[index]

    if last - index > 1
      simplifyDPStep points, index, last, sqTolerance, simplified

simplifyDouglasPeucker = (points, sqTolerance) ->
  last = points.length - 1
  simp = points.slice(0, 1)
  simplifyDPStep points, 0, last, sqTolerance, simp
  simp.push points[last]
  simp

simplify = (points, tolerance = 1, highQuality) ->
  if points.length <= 2
    return points
  else
    sqTol  = Math.pow(tolerance, 2)
    points = if highQuality then points else simplifyRadialDist(points, sqTol)
    return simplifyDouglasPeucker(points, sqTol)


module.exports = simplify
